import { render, staticRenderFns } from "./batchInput.vue?vue&type=template&id=19310a80&scoped=true"
import script from "./batchInput.vue?vue&type=script&lang=js"
export * from "./batchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19310a80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19310a80')) {
      api.createRecord('19310a80', component.options)
    } else {
      api.reload('19310a80', component.options)
    }
    module.hot.accept("./batchInput.vue?vue&type=template&id=19310a80&scoped=true", function () {
      api.rerender('19310a80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/batchInput.vue"
export default component.exports